export class TranscodingDestination {
  constructor(
    public id: number,
    public name: string,
    public defaultSelected: boolean,
  ) {}
}
